
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySnowShowersPolartwilight as ObiLightningHeavySnowShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-snow-showers-polartwilight.js';
 
 
 

 
 export const ObiLightningHeavySnowShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-snow-showers-polartwilight',
   elementClass: ObiLightningHeavySnowShowersPolartwilightElement,
   events: {
     
   }
  });
 
 